const initialState = {
  index: -1,
  list: ["xatlov", "yeoju", "perimeter", "dash_transports", "dash_perimeter", "dash_top", "alarm_history", "ytx", "ytx_death", "choraxa"]
}

const scenarioReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_INDEX":
      return { ...state, index: action.data }
    case "INCREMENT_INDEX":
      return { ...state, index: state.index !== state.list.length - 1 ? state.index + 1 : state.index }
    case "DECREMENT_INDEX":
      return { ...state, index: state.index !== -1 ? state.index - 1 : state.index }
    case "RESET_INDEX":
      return { ...state, index: -1 }

    default:
      return state
  }
}

export default scenarioReducer
